import { useContextSelectors } from "@-/com.npmjs.use-context-selectors";
import { MorphemeInfoPanelContext } from "@-/dev.improve.haniverse.routes.nav.app._components.morpheme.panels._components.panel-content._context";
import { GraphemeDictionaryTopSheet } from "#grapheme-dictionary-top-sheet";
import { WordDictionaryTopSheet } from "#word-dictionary-top-sheet";
import type {
  ReferenceGraphemeMorphemeSlice,
  ReferenceWordMorphemeSlice,
} from "@-/dev.improve.haniverse.lib.morpheme.entities";

export function MorphemeInfoPanelDictionaryTab() {
  const [infoBackCardSlice] = useContextSelectors(
    MorphemeInfoPanelContext,
    (c) => c.infoBackCardSlice.data,
  );
  if (infoBackCardSlice.morphemeType === "grapheme") {
    return <MorphemeInfoPanelDictionaryGraphemeTab graphemeCard={infoBackCardSlice} />;
  }
  return <MorphemeInfoPanelDictionaryWordTab wordCard={infoBackCardSlice} />;
}

function MorphemeInfoPanelDictionaryGraphemeTab({
  graphemeCard,
}: {
  graphemeCard: ReferenceGraphemeMorphemeSlice;
}) {
  return <GraphemeDictionaryTopSheet graphemeCard={graphemeCard} />;
}

function MorphemeInfoPanelDictionaryWordTab({
  wordCard,
}: {
  wordCard: ReferenceWordMorphemeSlice;
}) {
  return <WordDictionaryTopSheet wordCard={wordCard} />;
}
